export type {LockerAssignment} from './LockerAssignment';
export type {ParcelData} from './ParcelData';
export  {LockerType} from './LockerType';
export  {LockerSize} from './LockerSize';

export enum UserTypeEnum {
    Company = 'company',
    Personal = 'personal'
  }
  
  export type UserType = UserTypeEnum | null;
